import PropTypes from "prop-types"
import { get } from "lodash"
import { Table, TableHead, TableRow, TableCell } from "@mui/material"
import { numberFormatter } from "helpers/formatters/numbers"
import { useTrack } from "helpers/analytics"
import { sortData } from "helpers/contributorsSort"
import ContributorsOptions from "components/contributors-options"
import ContributorsSorting from "components/contributors-sorting"
import ContributorsTableContent from "components/contributors-table-content"
import ContributorsTableHead from "components/contributors-table-head"
import "./style.scss"

function ForecastContributors({
  selectedContributorCategory,
  selectedContributorValue,
  showContributorCategory,
  data,
  openSecurityProfile,
  selectedGroup,
  selectedGroupSiblings,
  showGroup,
  setGrouping,
  currentGrouping,
  groupedData,
  openFactorProfile,
  sortOrder,
  setSortOrder,
  availableRollups,
  contributorsSummaryText,
  excelData,
  selectedOption,
  selectedGroupValue,
  hideGroup,
  details,
  groupOrder,
  groupsDropdownColumns,
}) {
  const trackExcelDownload = useTrack({
    type: "composite-analyze-forecast-contributors-download",
  })

  const onBackClick = selectedGroup ? hideGroup : null
  const selectedOptionColor = get(selectedOption, "color")

  return <div className="contributors-details-wrapper">
    <ContributorsOptions {...{
      contributorsSummaryText,
      availableRollups,
      setGrouping,
      currentGrouping,
      selectedGroup,
      csvData: excelData,
      trackExcelDownload,
    }}
    />
    <Table className="contributors-details-table">
      <TableHead>
        <TableRow>
          <TableCell colSpan={3} align="right" title="% Contribution" className="contribution-dropdown-wrapper">
            <div>
              Avg. Weighted %
            </div>
          </TableCell>
        </TableRow>
        <TableRow className="sorting-row">
          <ContributorsSorting label="Name" id="name" order={sortOrder} sort={setSortOrder} />
          <ContributorsSorting align="right" label="% Equity" id="equity" order={sortOrder} sort={setSortOrder} />
          <ContributorsSorting align="right" label="Contribution" id="viewType" order={sortOrder} sort={setSortOrder} />
        </TableRow>
        <TableRow>
          <ContributorsTableHead
            label={selectedGroup ? selectedGroup.name : selectedContributorCategory.label}
            color={selectedOptionColor}
            onBackClick={onBackClick}
            dropdownColumns={groupsDropdownColumns}
            dropdownItems={selectedGroup ? selectedGroupSiblings : sortData(details, groupOrder)}
            onDropdownItemClick={(item) => selectedGroup ? showGroup(item) : showContributorCategory(item)}
            selectedItemId={selectedGroup ? selectedGroup.id : selectedContributorCategory.id}
          />
          <TableCell align="right" style={{ color: selectedOptionColor }}>{selectedGroup ? numberFormatter(selectedGroup.totalPercentEquity * 100) : "-"}</TableCell>
          <TableCell align="right" style={{ color: selectedOptionColor }}>{numberFormatter(selectedGroup ? selectedGroupValue : selectedContributorValue * 100) || "-"}</TableCell>
        </TableRow>
      </TableHead>
      <ContributorsTableContent
        selected={selectedContributorCategory}
        openSecurityProfile={openSecurityProfile}
        openFactorProfile={openFactorProfile}
        data={data}
        contributorsGrouping={currentGrouping}
        selectedGroup={selectedGroup}
        showGroup={showGroup}
        groupedData={groupedData}
      />
    </Table>
  </div>
}

ForecastContributors.propTypes = {
  classifications: PropTypes.array,
  selectedContributorCategory: PropTypes.object.isRequired,
  selectedContributorValue: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  segment: PropTypes.object,
  viewType: PropTypes.string.isRequired,
  showContributorCategory: PropTypes.func,
  sortOrder: PropTypes.object.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedGroupSiblings: PropTypes.array,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  setGrouping: PropTypes.func.isRequired,
  currentGrouping: PropTypes.object,
  groupedData: PropTypes.array,
  availableRollups: PropTypes.array.isRequired,
  contributorsSummaryText: PropTypes.string.isRequired,
  excelData: PropTypes.object.isRequired,
  selectedOption: PropTypes.object.isRequired,
  selectedGroupValue: PropTypes.number,
  forecastId: PropTypes.string.isRequired,
  details: PropTypes.array.isRequired,
  groupsDropdownColumns: PropTypes.array,
}

export default ForecastContributors
